export default __webpack_public_path__ + "588a8c4a69ef3418d270b8978e6ab8dc.png";